export const selectSmsLongCode = state => state.clientEvents.smsLongCode
